type localesKeys__UserButton = {
  userButton__ariaLabel: string;
  userButton__calloutTitle: string;
  userButton__logoutButton: string;
  userButton__cancelButton: string;
};

const ruLocale__UserButton: localesKeys__UserButton = {
  userButton__ariaLabel: 'Меню пользователя',
  userButton__calloutTitle: 'Вы хотите разлогиниться?',
  userButton__logoutButton: 'Выйти',
  userButton__cancelButton: 'Отмена',
};

const enLocale__UserButton: localesKeys__UserButton = {
  userButton__ariaLabel: 'User menu',
  userButton__calloutTitle: 'Do you want to log out?',
  userButton__logoutButton: 'Log out',
  userButton__cancelButton: 'Cancel',
};

export { ruLocale__UserButton, enLocale__UserButton };
export type { localesKeys__UserButton };
